import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AppConstants } from 'src/app/models/AppConstants';
import { NotificationType } from 'src/app/models/notification.message';

import { LoginRequest } from 'src/app/models/requests/login-request';
import { LoginResponseData } from 'src/app/models/responses/login-response-data';
import { ErrorResponse } from 'src/app/responses/error-response';
import { NotificationService } from 'src/app/services/notification.service';
import { SharedService } from 'src/app/services/shared.service';

import { TokenService } from 'src/app/services/token.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-access',
  templateUrl: './access.component.html',
  styleUrls: ['./access.component.css']
})
export class AccessComponent implements OnInit {
visible:boolean = true;
changetype:boolean = true;
isRemberMeChecked=false;
email: string = '';
token?: string;
isSubmitting: boolean = false; 
isLoggingInAs: boolean = false; 

cachedEmail: any;
cachedName: any;
isAvailable: boolean = false;

viewpassword(){
  this.visible = !this.visible;
  this.changetype = !this.changetype;
}
  @Output() emitData = new EventEmitter<LoginResponseData>();

  today = new Date();
  loginRequest: LoginRequest = {
    email: '',
    password: ''
  };
  loginPage: boolean = true;

  isLoggedIn = false;
  isLoginFailed = false;
  error: ErrorResponse = { error: '', errorCode: 0 };
  constructor(private userService: UserService, private tokenService: TokenService, private router: Router,
   private route: ActivatedRoute, private notification: NotificationService, private sharedService: SharedService) { }


  loginResponseData: LoginResponseData | undefined;


  ngOnInit(): void {


this.route.queryParams.subscribe(params => {
  const token = params['to'];

  if(token){
    const request = {
      token : token
    }
    this.userService.loginWithToken(request).subscribe(
      (response) => {
        if(response.requestSuccessful){
          this.tokenService.saveSession(response.responseData.login)
          this.tokenService.setInfo(response.responseData.login)
           this.notification.sendMessage({
              message: response.message,
              type: NotificationType.success
            });
          this.router.navigate([response.responseData.path || 'Dashboard']);
        }
      },
        (error) => {
          console.error('Invalid token in URL.')
        }
    )
  }else {
    console.error('No token found in Url.')

    this.cachedEmail = localStorage.getItem('EM');
      this.cachedName = localStorage.getItem('FN');
      if(this.cachedEmail && this.cachedName){
        this.isAvailable = true;
      }

  }
})
    if(JSON.parse(localStorage.getItem('isRemberMeChecked')!) !== null)
{
 // this.name = localStorage.getItem('Name');
  this.isRemberMeChecked = JSON.parse(localStorage.getItem('isRemberMeChecked')!);

  if(this.isRemberMeChecked)
  {
    let accessToken = this.tokenService.getSession()?.accessToken;
    if(accessToken!.length>0)
    {
      if (this.tokenExpired(accessToken!)) {
        // token expired
      } else {
        // token valid
      }
      
      let decodedJWT = JSON.parse(window.atob(accessToken!.split('.')[1]));
      let email= decodedJWT.email;
      this.autoLogin(email);
    }
  }
}
    /*
    let isLoggedIn = this.tokenService.isLoggedIn();
    console.log(`isLoggedIn: ${isLoggedIn}`);
    if (isLoggedIn) 
    {
      this.isLoggedIn = true;
      

     // this.router.navigate(['tasks']);
    }
    */
  }

  getCode() {
    
    console.log('this button clicked');
    this.isSubmitting = true;
    const email = this.loginRequest.email;
    
   
    this.userService.requestLoginCode(email).subscribe(
      data => {
        ;
        // console.log(data.responseCode);
        // console.log(data);
          if (data.requestSuccessful) {
            ;
            this.toggleForm();
            this.isSubmitting = false;
            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.success
            });
          } else {
            ;
            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.error
            });
            this.isSubmitting = false;
          }
        }, 
      
      error => {
       
        console.error('Error requesting login code', error);
        this.notification.sendMessage({
          message: 'Email not found', 
          type: NotificationType.error
        });
        this.isSubmitting = false;
      }
    );
  }

  verifyCode(): void {
    
    this.isSubmitting = true;
     var token = this.loginRequest.code as string;
     
     this.userService.validateLoginCode(token).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.tokenService.saveSession(data.responseData);
          this.tokenService.setInfo(data.responseData);
                    this.isLoggedIn = true;
                    this.isLoginFailed = false;
                   
          
                    // this.getinfo();
                    this.isSubmitting = false;
                    this.router.navigate(['']).then(() => {window.location.reload()});

                    

                    
          
                  }
        else {
          this.isSubmitting = false;
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;
        this.error = error;
        this.isSubmitting = false;

        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }

  loginAs(){
      
      this.isLoggingInAs = true;
      this.isSubmitting = true;
      this.userService.loginAs(this.cachedEmail).subscribe(
            (response) => {
              if(response.requestSuccessful){

                this.tokenService.saveSession(response.responseData);
                this.tokenService.setInfo(response.responseData);
                this.isLoggedIn = true;
                this.isLoginFailed = false;
                AppConstants.UserPermission = response.responseData.permission;
                AppConstants.IsSuperAdmin = response.responseData.profile.isSuperAdmin;
  
                this.router.navigate(['']).then(() => {window.location.reload()});
              }

            },
            (error) => {
              console.error(error.error.message);
              this.isLoggingInAs = false;
              this.isSubmitting = false;
            }
          );
    }

  toggleFormBack() {
    this.loginPage = true;
    this.loginRequest.code = ''; // Clear the code input
  }

  onSubmit(): void {

    this.userService.login(this.loginRequest).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          //   console.debug(`logged in successfully ${data}`);

          this.loginResponseData = data.responseData;

          this.sharedService.loginResponseData = data.responseData;
          this.tokenService.saveSession(data.responseData);
          this.tokenService.setInfo(data.responseData);
          this.isLoggedIn = true;
          this.isLoginFailed = false;
          AppConstants.UserPermission = data.responseData.permission;
          AppConstants.IsSuperAdmin = data.responseData.profile.isSuperAdmin;

          if (this.loginResponseData.profile.mustChangePassword == true) {
            this.router.navigate(['passwordreset']);
          }
          else {

            ;
            if(this.isRemberMeChecked){
           //  localStorage.setItem('Name', credentials.firstName);
              localStorage.setItem('isRemberMeChecked', JSON.stringify(this.isRemberMeChecked));
            }
            else
            {  localStorage.removeItem('isRemberMeChecked');}


            this.router.navigate(['']).then(() => {window.location.reload()});
          }

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;
        this.error = error;
        this.isLoggedIn = false;
        this.isLoginFailed = true;

        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }

  reloadPage(): void {
    window.location.reload();
  }

  toggleForm() {
    this.isSubmitting = false;
    this.loginPage = false;
  }

  onReset(): void {
    ;
    this.userService.passwordReset(this.loginRequest).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          this.router.navigate(['/signin']);

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;
        this.error = error;

        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }

  private tokenExpired(token: string) {
    ;
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    let result = (Math.floor((new Date).getTime() / 1000)) >= expiry;
    return (Math.floor((new Date).getTime() / 1000)) >= expiry;

  }
 
  autoLogin(emai:string): void {
let obt = {
email:emai
};
    this.userService.passwordlessSignIn(obt).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          //   console.debug(`logged in successfully ${data}`);

          this.loginResponseData = data.responseData;

          this.sharedService.loginResponseData = data.responseData;
          this.tokenService.saveSession(data.responseData);
          this.tokenService.setInfo(data.responseData);
          this.isLoggedIn = true;
          this.isLoginFailed = false;
          AppConstants.UserPermission = data.responseData.permission;
          AppConstants.IsSuperAdmin = data.responseData.profile.isSuperAdmin;

          if (this.loginResponseData.profile.mustChangePassword == true) {
            this.router.navigate(['passwordreset']);
          }
          else {

            ;
            if(this.isRemberMeChecked){
           //  localStorage.setItem('Name', credentials.firstName);
              localStorage.setItem('isRemberMeChecked', JSON.stringify(this.isRemberMeChecked));
            }
            else
            {  localStorage.removeItem('isRemberMeChecked');}


            this.router.navigate(['']).then(() => {window.location.reload()});
          }

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;
        this.error = error;
        this.isLoggedIn = false;
        this.isLoginFailed = true;

        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }
}
